export const CREW_MEMBER_ACTION_LOG_TEXT = {
	actionHeader: 'Action',
	detailsHeader: 'Details',
	categoryHeader: 'Category',
	dateTimeHeader: 'Date & time',
	userHeader: 'User',
	emptyRow: 'No actions yet',
	periodLabel: 'Period',
	categoryLabel: 'Category',
};
